import React, {useCallback, useContext, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {Card, CardActions, CardContent, CardHeader, Tooltip, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import Button from "@mui/material/Button";
import {useForm, FormProvider} from "react-hook-form";
import {AnagraficaContext, AppContext} from "../../../../App";
import clsx from "clsx";
import {updateAnagrafica} from "../../../../services/AnagraficaServices";
import {resetAnagrafica} from "../../interviste/intervista/utils/ResetUtils";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../services/AppServices";

const AnagraficaTamponeCard = ({anagrafica}) => {
	const classes = BaseStyle();
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const methods = useForm({
		mode: "onChange",
		defaultValues: resetAnagrafica(anagrafica)
	});
	const [resetUpdate, setResetUpdate] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setResetUpdate(true)
		updateAnagrafica(getAnaGraficaApi({
			...data,
			idSoggetto: anagrafica?.idSoggetto,
			tipoDocumento: data.tipoDocumento ? data.tipoDocumento : "Codice fiscale",
		}), anagrafica?.idSoggetto, anagraficaContext.dispatch);
	}, [anagrafica, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (resetUpdate && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setOpenSnackbar("success", "Anagrafica aggiornata correttamente", appContext.dispatch);
			setResetUpdate(false);
			methods.reset(resetAnagrafica({...anagraficaContext.state.anagrafica}));
		}
	}, [anagraficaContext.state.loadingUpdateAnagrafica, anagraficaContext.state.errorUpdateAnagrafica, resetUpdate, anagraficaContext.state.anagrafica, methods, appContext.dispatch])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder)} style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Anagrafica paziente</b></Typography>}
				/>
				<CardContent style={{flexGrow: 1}}>
					<form onSubmit={methods.handleSubmit(onSubmit)}>
						<FormProvider {...methods}>
							<Grid container spacing={3}>
								<AnagraficaCompleta classes={classes} intro={"req"} moreInfo={true} anonimo={true}
								                    anagrafica={anagrafica}/>
							</Grid>
						</FormProvider>
					</form>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Vai alla pagina della gestione del singolo paziente"}>
						<Button variant={"text"} disableElevation size="small" type={"submit"}
						        style={{borderRadius: 24}}
						        className={classes.roundButton}
						        onClick={() => window.open("https://ocean.aslcittaditorino.it/gestione/pazienti/" + anagrafica?.idSoggetto)}>
							<b>Dettaglio paziente</b>
						</Button>
					</Tooltip>
					<Tooltip
						title={"Aggiorna l'anagrafica paziente"}>
						<Button variant={"contained"} disableElevation size="small" color="primary" type={"submit"}
						        style={{borderRadius: 24}}
						        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
							<b>Aggiorna anagrafica</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
		</React.Fragment>
	);
};

export default AnagraficaTamponeCard;
